import React, { useState } from 'react';
import { freightClasses } from '../../../initial-values';
import FreightModal from './freightModal';
interface Props {
  packagesForm: any;
  setPackagesForm: any;
  isSavedpackages?: boolean;
  validating?: boolean;
}
function FreightClassField({
  packagesForm,
  setPackagesForm,
  isSavedpackages,
  validating,
}: Props) {
  const [openModal, setOpenModal] = useState(false);
  return (
    <div
      className={`${isSavedpackages ? 'row mt-2' : 'row mt-4'}`}
      id='skid_fields'
    >
      <div className='col-sm-12'>
        <div className='row'>
          <div
            className={`${
              isSavedpackages ? 'col-md-12' : 'col-md-10'
            } col-sm-12`}
          >
            <label
              className={`globalInputLabel ${
                isSavedpackages ? 'pb-1' : 'pb-2'
              }`}
              htmlFor='main_freight_className'
            >
              Freight class{' '}
              <span
                className='text-danger fw-bold'
                style={{ marginLeft: '3px' }}
              >
                *
              </span>
            </label>
            <select
              className={`form-select form-control ubbe-input globalInputLabel ${
                packagesForm?.freight_class_id || packagesForm?.freight_class
                  ? 'highlighted-border'
                  : ''
              }`}
              id='main_freight'
              data-width='100%'
              data-size='8'
              value={
                isSavedpackages
                  ? packagesForm?.freight_class_id
                  : packagesForm?.freight_class
              }
              defaultValue={
                isSavedpackages
                  ? packagesForm?.freight_class_id
                  : packagesForm?.freight_class
              }
              onChange={(e) => {
                if (isSavedpackages) {
                  setPackagesForm({
                    ...packagesForm,
                    freight_class_id: e.target.value,
                  });
                } else {
                  setPackagesForm({
                    ...packagesForm,
                    freight_class: e.target.value,
                  });
                }
              }}
            >
              {freightClasses &&
                freightClasses.length > 0 &&
                freightClasses.map((option: any) => (
                  <option
                    key={option.value}
                    value={option.value}
                    className='modal-box-edit'
                  >
                    {option.name}
                  </option>
                ))}
            </select>
          </div>
          {!isSavedpackages && (
            <div className='col-sm-12 col-md-2'>
              <label
                className='globalInputLabel pb-2'
                htmlFor=''
              >
                <span
                  className='text-danger fw-bold'
                  style={{ marginLeft: '3px' }}
                ></span>
              </label>
              <button
                type='button'
                className='btn btn-ubbe-blue w-100'
                data-bs-toggle='modal'
                data-bs-target='#freight_className_modal'
                style={{ height: '48px' }}
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Info
              </button>
            </div>
          )}
        </div>
        {validating && packagesForm?.freight_class === '-1' && (
          <div
            className='error_text'
            id='main_freight_className_error'
          >
            Please select a Freight className.
          </div>
        )}
      </div>
      {openModal && <FreightModal setOpenModal={setOpenModal} />}
    </div>
  );
}

export default FreightClassField;
